// extracted by mini-css-extract-plugin
export default {"activeLink":"Taluka_activeLink__0fh9G","sidenavTalukaList":"Taluka_sidenavTalukaList__hxgRJ","userIcon":"Taluka_userIcon__giW4B","link":"Taluka_link__rKHGz"};